import View from './TwoFactorAlert';
import enhancer from './TwoFactorAlert.enhancer';

export default enhancer(View);
